import { createSelector } from "@ngrx/store";
import { MovimientoTramiteState, movimientoTramiteAdapter } from "./movimiento-tramite.state";
import { MovimientoTramite } from "./movimiento-tramite.models";
import { VistaUsuarioState, selectVistaUsuario } from "../../vista-usuario/vista-usuario.state";
import { selectAllTramites } from "../tramite.selectors";
import { selectCurrentEmpresa } from "../../empresas/entity-mis-empresas/entity-current-empresa.selectors";
import { selectAllTramiteStatus } from "../tramite-status/tramite-status.selectors";

const { selectEntities, selectAll } = movimientoTramiteAdapter.getSelectors();

export const selectMovimientoTramiteState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.movimientoTramite
);

export const getError = (state: MovimientoTramiteState): Error => state.error as any;

export const getIsLoading = (state: MovimientoTramiteState): boolean => state.isLoading;

export const selectAllMovimientoTramites = createSelector(selectMovimientoTramiteState, selectAll);

export const selectEntitiesTramite = createSelector(
  selectMovimientoTramiteState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectTramitesError = createSelector(selectMovimientoTramiteState, getError);

// MemoizedSelector<object,any>
export const selectTramitesIsLoading = createSelector(
  selectMovimientoTramiteState,
  getIsLoading
);

export const getMovimientoTramiteByCurrentEmpresa = createSelector(
  selectAllTramites,
  selectAllMovimientoTramites,
  selectCurrentEmpresa,
  selectAllTramiteStatus,
  (tramites, movimientos, empresa, tramiteStatus) => {
    if (!empresa) {
      return [];
    }

    const tramitesByEmpresa = tramites.filter((t) => t.entidad_relacion_id === empresa.id);
    let currentEmpresaMovimientos = movimientos.filter((m) => tramitesByEmpresa.some((t) => t.id === m.tramite_id));
    currentEmpresaMovimientos = currentEmpresaMovimientos.map((m) => {
      const estado = tramiteStatus.find((ts) => ts.estado_id === m.estado_id).estado_nombre;
      return {
        ...m,
        estado,
      };
    });

    return currentEmpresaMovimientos;
  }
);
